import { PromptsInterface } from "../types/Prompts";
import { apiUrls } from "./apiUrls";
import { makeRequest } from "./request";

class Prompts implements PromptsInterface {
  readonly apiKey: string;

  constructor(apiKey: string) {
    this.apiKey = apiKey;
  }

  async create_prompt(
    authorName: string,
    promptName: string,
    version: string,
    content: string,
    variables: Record<string, unknown>
  ): Promise<any> {
    const jsonData: Record<string, unknown> = {
      name: promptName,
      author_name: authorName,
      content,
      variables,
      version,
    };
    try {
      return await makeRequest(
        "POST",
        apiUrls.prompts.create,
        this.apiKey,
        {},
        jsonData
      );
    } catch (error) {
      console.error("Error creating prompt:", error);
    }
  }

  async add_prompt_version(
    promptId: string,
    version: string,
    content: string,
    variables: Record<string, unknown>
  ): Promise<any> {
    const jsonData: Record<string, unknown> = {
      prompt_id: promptId,
      content,
      variables,
      version,
    };
    try {
      return await makeRequest(
        "POST",
        apiUrls.prompts.addVersion,
        this.apiKey,
        {},
        jsonData
      );
    } catch (error) {
      console.error("Error adding prompt version:", error);
    }
  }

  async get_all_versions_by_prompt(promptId: string): Promise<any> {
    if (!promptId) {
      throw new Error("Prompt ID not found for this prompt");
    }
    const path = apiUrls.prompts.allVersions(promptId);
    try {
      const response = await makeRequest("GET", path, this.apiKey);
      return response.data;
    } catch (error) {
      console.error("Error fetching all prompt versions:", error);
    }
  }

  async update_prompt(authorName: string, promptName: string): Promise<any> {
    const jsonData = {
      name: promptName,
      author_name: authorName,
    };
    try {
      return await makeRequest(
        "POST",
        apiUrls.prompts.create,
        this.apiKey,
        {},
        jsonData
      );
    } catch (error) {
      console.error("Error updating prompt:", error);
    }
  }

  async get_prompt_version(
    authorName: string,
    promptName: string,
    version: string | null = null
  ): Promise<any> {
    const url = apiUrls.prompts.getVersion(authorName, promptName);
    const queryParams: Record<string, string> = version ? { version } : {};
    try {
      const response = await makeRequest("GET", url, this.apiKey, queryParams);
      return response.data;
    } catch (error) {
      console.error("Error fetching prompt version:", error);
    }
  }

  async get_prompts_by_author(authorName: string): Promise<any> {
    const path = apiUrls.prompts.byAuthor(authorName);
    try {
      const response = await makeRequest("GET", path, this.apiKey);
      return response.data;
    } catch (error) {
      console.error("Error fetching prompts by author:", error);
    }
  }
}

export default Prompts;
